import { createAsyncThunk, createSlice, createAction } from "@reduxjs/toolkit";
import { fetchLoggedInUser, fetchLoggedInUserOrders, updateUserInfo, deleteUserAddress, fetchUserAddresses, addUserNewAddress, fetchLoggedInUserOrderById, addItemInUserWishlist, fetchItemsInUserWishlist, removeItemFromUserWishlist } from "./userAPI";

const initialState = {
    userInfo: null,
    userOrders: [],
    userAddresses: [],
    userWishlist: [],
    status: "idle",
    fetchByIdOrder: null,
}

export const fetchLoggedInUserAsync = createAsyncThunk(
    'user/fetchLoggedInUser',
    async () => {
        const response = await fetchLoggedInUser();
        return response;
    }
);

export const updateUserInfoAsync = createAsyncThunk(
    'user/updateUserInfo',
    async (change) => {
        const response = await updateUserInfo(change);
        return response;
        //Only update firstname, lastname,email,password
    }
);

export const fetchLoggedInUserOrdersAsync = createAsyncThunk(
    'user/fetchLoggedInUserOrders',
    async (userId) => {
        const response = await fetchLoggedInUserOrders(userId);
        return response;
    }
)

export const fetchLoggedInUserOrderByIdAsync = createAsyncThunk(
    "dashboard/fetchLoggedInUserOrderById",
    async (orderId) => {
        const response = await fetchLoggedInUserOrderById(orderId);
        return response
    }
);

export const deleteUserAddressAsync = createAsyncThunk(
    'user/deleteUserAddress',
    async (addressId) => {
        const response = await deleteUserAddress(addressId);
        return response;
    }
)

export const fetchUserAddressesAsync = createAsyncThunk(
    'user/fetchUserAddresses',
    async () => {
        const response = await fetchUserAddresses();
        return response;
    }
)

export const addUserNewAddressAsync = createAsyncThunk(
    'user/addUserNewAddress',
    async (address) => {
        const response = await addUserNewAddress(address);
        return response;
    }
)

export const addItemInUserWishlistAsync = createAsyncThunk(
    'user/addItemInUserWishlist',
    async (productId) => {
        const response = await addItemInUserWishlist(productId);
        return response;
    }
)

export const fetchItemsInUserWishlistAsync = createAsyncThunk(
    'user/fetchItemsInUserWishlist',
    async () => {
        const response = await fetchItemsInUserWishlist();
        return response;
    }
)

export const removeItemFromUserWishlistAsync = createAsyncThunk(
    'user/removeItemFromUserWishlist',
    async (wishlistId) => {
        const response = await removeItemFromUserWishlist(wishlistId);
        return response;
    }
)




const listenIfNewOrderReceived = createAction('order/createNewOrder/fulfilled')

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetUserSlice: (state) => initialState,
        addNewOrderInUserOrder: (state, action) => {
            state.userOrders.unshift(action.payload.message) //Because i have seperate slice of order so when user make order we will trigger this action which will add the new order in frontend
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLoggedInUserAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLoggedInUserAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userInfo = action.payload.message
                }
            })
            .addCase(updateUserInfoAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateUserInfoAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userInfo = action.payload.message
                }
            })
            .addCase(fetchLoggedInUserOrdersAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLoggedInUserOrdersAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userOrders = action.payload.message
                }
            })
            .addCase(fetchLoggedInUserOrderByIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchLoggedInUserOrderByIdAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.fetchByIdOrder = action.payload.message
                }
            })
            .addCase(deleteUserAddressAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteUserAddressAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userAddresses = state.userAddresses.filter(address => address.id !== action.payload.message)
                }
            })
            .addCase(fetchUserAddressesAsync.pending, (state, action) => {
                state.status = 'loading';
            })
            .addCase(fetchUserAddressesAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userAddresses = action.payload.message;
                }
            })
            .addCase(addUserNewAddressAsync.pending, (state, action) => {
                state.status = 'loading';
            })
            .addCase(addUserNewAddressAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userAddresses.push(action.payload.message);
                }
            })
            .addCase(listenIfNewOrderReceived, (state, action) => { //This will match with orderslice reducer
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    if (state.userOrders.length !== 0) { //Because agar userOrder nai h to phle backend se check krna pdega ki user ke or bhi orders h ya nai nai to frontend m sirf new order hi show hoga 
                        state.userOrders.unshift(action.payload.message);
                    }
                }
            })

            .addCase(addItemInUserWishlistAsync.pending, (state, action) => {
                state.status = 'loading';
            })
            .addCase(addItemInUserWishlistAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userWishlist.push(action.payload.message)
                }
            })
            .addCase(fetchItemsInUserWishlistAsync.pending, (state, action) => {
                state.status = 'loading';
            })
            .addCase(fetchItemsInUserWishlistAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userWishlist = action.payload.message;
                }
            })
            .addCase(removeItemFromUserWishlistAsync.pending, (state, action) => {
                state.status = 'loading';
            })
            .addCase(removeItemFromUserWishlistAsync.fulfilled, (state, action) => {
                state.status = 'succeeded';
                if (action.payload.status === "success") {
                    state.userWishlist = state.userWishlist.filter(wishlist => wishlist.productId !== action.payload.message)
                }
            })

    }
});

//selector
export const fetchByIdOrder = (state) => state.user.fetchByIdOrder;
export const userInfo = (state) => state.user.userInfo;
export const userAddresses = (state) => state.user.userAddresses;
export const userWishlist = (state) => state.user.userWishlist;
export const isLoadingUserSlice = (state) => state.user.status === 'loading';

//actions 
export const { resetUserSlice } = userSlice.actions; //When user logout will dispatch the action
export const { addNewOrderInUserOrder } = userSlice.actions; //When user logout will dispatch the action

export default userSlice.reducer;